import { lazy } from "react";
import { connect } from "react-redux";
import {
  loading,
  data,
  pagination,
} from "../../../store/administration/selectors/financial_entities";

const FinancialEntities = lazy(() => import("./FinancialEntities"));

const mapStateToProps = (state) => ({
  isLoading: loading(state),
  financialEntities: data(state),
  pagination: pagination(state),
});

export default connect(mapStateToProps)(FinancialEntities);
